import { render, staticRenderFns } from "./OfficeStaffNewPage.vue?vue&type=template&id=0d5e4ac0&"
import script from "./OfficeStaffNewPage.vue?vue&type=script&lang=ts&"
export * from "./OfficeStaffNewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports